import { render, staticRenderFns } from "./JourneyGroup.vue?vue&type=template&id=45a4b5a6&scoped=true&"
import script from "./JourneyGroup.vue?vue&type=script&lang=js&"
export * from "./JourneyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a4b5a6",
  null
  
)

export default component.exports